var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['default-image-box', _vm.zoomClass?'img-zoom':'']},[_c('img',{attrs:{"src":_vm.finalSrcImg,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }